import type { ICustomError } from '../interfaces/error';
import { buildErrorFromResponse } from './errorUtils';

type ToastType = 'neutral' | 'success' | 'warning' | 'error' | 'info';

export const showToast = (type: ToastType, dismissible: boolean, message: string, header = '') => {
    document.dispatchEvent(
        new CustomEvent('show-toast', {
            detail: { header, message, type, dismissible, hasIcon: true, position: 'top-center' },
        }),
    );
};

export const showSuccessToast = (message: string, dismissible = false) => showToast('success', dismissible, message);

export const showWarningToast = (customError: ICustomError, dismissible = false) => {
    const error = buildErrorFromResponse(customError);
    if (error) {
        showToast('warning', dismissible, error.userMessage);
    }
};

export const showErrorToast = (customError: ICustomError, dismissible = false) => {
    const error = buildErrorFromResponse(customError);
    if (error) {
        showToast('error', dismissible, error.userMessage);
    }
};

export const showNeutralToast = (message: string, dismissible = false) => showToast('neutral', dismissible, message);

export const showInfoToast = (message: string, dismissible = false) => showToast('info', dismissible, message);
